// extracted by mini-css-extract-plugin
export default {"main":"_74de128fa2 b08c38ddf5","xmark":"_150d2ff356","fl_img":"_9de086c936 _072b18824b"};